import Confirm from '../../components/layout/wxConfirm';

// SOURCE: https://github.com/stalniy/casl-vue-api-example/tree/master/src/plugins
function WxConfirmPlugin(Vue: any, options: any = {}) {
    const vuetify = options.vuetify;
    if (!vuetify) {
        // tslint:disable-next-line: max-line-length
        Vue.prototype.$log.error(`Module vuetify-confirm needs vuetify instance.
        Use Vue.use(VuetifyConfirm, { vuetify })`);
    }

    const ConfirmComponent = Vue.extend(Confirm);

    Vue.prototype.$confirm = (message: string, params: any = {}) => {
        const confirm = new ConfirmComponent({
            vuetify,
            propsData: {
                message,
                title: params.title,
                params,
            },
        });

        confirm.$mount();
        confirm.value = true;

        return new Promise((resolve) => {
            confirm.$once('input', (isAccepted: boolean) => {
                confirm.value = false;
                return resolve(isAccepted);
            });
        });
    };
}

export { WxConfirmPlugin };
// export default ConfirmPlugin;
